﻿package com.mgacreative.hotelru.domain.repository

import com.mgacreative.hotelru.core.network.SupabaseNetworkClient
import com.mgacreative.hotelru.core.tenant.TenantSession
import com.mgacreative.hotelru.domain.model.Staff
import io.github.jan.supabase.postgrest.postgrest
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class StaffRepository(
    private val networkClient: SupabaseNetworkClient,
    private val tenantSession: TenantSession
) {
    private val _staffList = MutableStateFlow<List<Staff>>(emptyList())
    val staffList: StateFlow<List<Staff>> = _staffList.asStateFlow()

    suspend fun loadStaff() {
        try {
            val tenantId = tenantSession.currentTenantId
            if (tenantId != null) {
                val response = networkClient.client.postgrest["staff"]
                    .select {
                        filter {
                            eq("tenant_id", tenantId)
                        }
                    }.decodeList<Staff>()
                _staffList.value = response
            }
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
        }
    }

    suspend fun addStaff(staff: Staff): Boolean {
        return try {
            val tenantId = tenantSession.currentTenantId
            if (tenantId != null) {
                val staffWithTenant = staff.copy(tenant_id = tenantId)
                networkClient.client.postgrest["staff"]
                    .insert(staffWithTenant)
                loadStaff() // Refresh list
                true
            } else {
                false
            }
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            false
        }
    }
}

